// Angular
import { Router } from '@angular/router';
import { ChangeDetectionStrategy, Component, OnDestroy, OnChanges, SimpleChanges, inject, input } from '@angular/core';

// RXJS & NGRX
import { Store } from '@ngrx/store';

import * as fromRoot from '../../../reducers';
import * as olci from '../../../actions/olci';
import { constants } from '../../../constants';
import * as tracking from '../../../actions/tracking';
import { LoaderService } from '../../loading/loader.service';
import { AuthenticationService } from '../../../shared/services/authentication/authentication.service';

@Component({
    selector: 'app-exit-confirmation',
    templateUrl: './modal-exit-confirmation.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ModalExitConfirmationComponent implements OnChanges, OnDestroy {
  public readonly layoutState = input<any>();
  public readonly bundle = input<any>();
  public exitConfirmationModal: boolean;
  private readonly authenticationService = inject(AuthenticationService);

  public constructor(
    private readonly store: Store<fromRoot.AppState>,
    private readonly loader: LoaderService,
    private readonly router: Router
  ) {
    this.exitConfirmationModal = false;
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes['layoutState']) {
      const layoutState = changes['layoutState'].currentValue;

      if (layoutState && layoutState.openedModalName === constants.MODAL.EXIT) {
        if (this.router.url !== constants.ROUTES.CONFIRMATION_PAGE) {
          this.exitConfirmationModal = true;
          this.store.dispatch(new tracking.TrackPageInteractionEventAction('modal: exit confirmation: leaving check-in?'));
          const inert = document.createAttribute('inert');
          document.getElementById('main')?.setAttributeNode(inert);
        } else {
          this.loader.showLoader();
          this.endSession();
        }
      } else if (layoutState && layoutState.openedModalName === 'close') {
        this.exitConfirmationModal = false;
        document.getElementById('main')?.removeAttribute('inert');
      }
    }
  }

  public ngOnDestroy(): void {
    document.getElementById('main')?.removeAttribute('inert');
    setTimeout(() => {
      document.getElementById('my-account-button')?.focus();
    }, 100);
  }

  private endSession(): void {
    this.authenticationService.endSession({
      exitUrl: this.layoutState().exitUrl,
      logoutFromGA: this.layoutState().logoutFromGA
    });
  }

  public yesContinue(): void {
    this.store.dispatch(
      new tracking.TrackPageCustomInteractionEventAction({
        event: 'leaveCheckin',
        interaction: 'modal: exit confirmation: yes',
      })
    );
    this.loader.showLoader();
    window.localStorage.removeItem(
      constants.LOCAL_STORAGE_KEYS.MOBILE_AD_MODAL
    );
    this.endSession();
  }

  public closeModal(): void {
    this.exitConfirmationModal = false;
    setTimeout(() => {
      this.store.dispatch(new olci.CloseModalAction());
    }, 0);
    this.store.dispatch(
      new tracking.TrackPageCustomInteractionEventAction({
        event: 'stayCheckin',
        interaction: 'modal: exit confirmation: no',
      })
    );
  }
}
